import * as types from "../types";
import { apolloClient } from "@/plugins/apollo";
import {
    PRODUCTS_QUERY,
    SINGLE_PRODUCT_QUERY,
    CREAT_PRODUCT_MUTATION,
    UPDATE_PRODUCT_MUTATION,
    UPDATE_PRODUCT_ITEMS_MUTATION,
    DELETE_PRODUCT_MUTATION
} from "@/graphql/products.js";

const state = {
    products: [],
    currentProduct: null
};
const getters = {};
const mutations = {
    [types.SET_PRODUCTS](state, products) {
        state.products = products;
    },
    [types.SORT_PRODUCTS](state) {
        state.products.sort(function(a, b) {
            return a.node.name.toLowerCase() == b.node.name.toLowerCase()
                ? 0
                : a.node.name.toLowerCase() > b.node.name.toLowerCase()
                ? 1
                : -1;
        });
    },
    [types.UPSERT_PRODUCT](state, product) {
        var index = state.products.findIndex(function(element) {
            return element.node.id == product.id;
        });

        const node = { node: product };

        if (index > -1) {
            state.products.splice(index, 1, node);
        } else {
            state.products.unshift(node);
        }
    },
    [types.DELETE_PRODUCT](state, product) {
        var index = state.products.find(function(element, index) {
            if (element.id == product.id) {
                return index;
            }
        });

        if (index > -1) {
            state.products.splice(index, 1);
        }
    }
};
const actions = {
    async fetchProducts(context) {
        return new Promise((resolve, reject) => {
            apolloClient
                .query({
                    query: PRODUCTS_QUERY,
                    fetchPolicy: "cache-first"
                })
                .then(response => {
                    // console.log(response);
                    const products = response.data.tenantProducts.edges;

                    // update store
                    context.commit(types.SET_PRODUCTS, products);

                    // sort
                    context.commit(types.SORT_PRODUCTS);

                    resolve(products);
                })
                .catch(error => {
                    // console.log(error);
                    reject(error);
                });
        });
    },

    async fetchSingleProduct(context, payload) {
        return new Promise((resolve, reject) => {
            apolloClient
                .query({
                    query: SINGLE_PRODUCT_QUERY,
                    fetchPolicy: "network-only",
                    variables: {
                        id: payload
                    }
                })
                .then(response => {
                    const product = JSON.parse(JSON.stringify(response.data.product));

                    // update store
                    context.commit(types.UPSERT_PRODUCT, product);

                    // sort
                    context.commit(types.SORT_PRODUCTS);

                    resolve(product);
                })
                .catch(error => {
                    // console.log(error);
                    reject(error);
                });
        });
    },

    async createProduct(context, payload) {
        return new Promise((resolve, reject) => {
            apolloClient
                .mutate({
                    mutation: CREAT_PRODUCT_MUTATION,
                    variables: {
                        input: payload
                    }
                })
                .then(response => {
                    const product = response.data.createProduct.product;

                    // update store
                    context.commit(types.UPSERT_PRODUCT, product);

                    // sort
                    context.commit(types.SORT_PRODUCTS);

                    resolve(product);
                })
                .catch(error => {
                    // console.log(error);
                    reject(error);
                });
        });
    },

    async updateProduct(context, payload) {
        return new Promise((resolve, reject) => {
            apolloClient
                .mutate({
                    mutation: UPDATE_PRODUCT_MUTATION,
                    variables: {
                        input: payload
                    }
                })
                .then(response => {
                    const product = response.data.updateProduct.product;

                    // update store
                    context.commit(types.UPSERT_PRODUCT, product);

                    // sort
                    context.commit(types.SORT_PRODUCTS);

                    resolve(product);
                })
                .catch(error => {
                    // console.log(error);
                    reject(error);
                });
        });
    },

    async updateProductItems(context, payload) {
        return new Promise((resolve, reject) => {
            apolloClient
                .mutate({
                    mutation: UPDATE_PRODUCT_ITEMS_MUTATION,
                    variables: {
                        input: payload
                    }
                })
                .then(response => {
                    const product = response.data.updateProductItems.product;

                    // update store
                    context.commit(types.UPSERT_PRODUCT, product);

                    // sort
                    context.commit(types.SORT_PRODUCTS);

                    resolve(product);
                })
                .catch(error => {
                    // console.log(error);
                    reject(error);
                });
        });
    },

    async deleteProduct(context, payload) {
        return new Promise((resolve, reject) => {
            apolloClient
                .mutate({
                    mutation: DELETE_PRODUCT_MUTATION,
                    variables: {
                        input: payload
                    }
                })
                .then(response => {
                    const product = response.data.deleteProduct.product;

                    // update store
                    context.commit(types.DELETE_PRODUCT, product);

                    resolve(product);
                })
                .catch(error => {
                    // console.log(error);
                    reject(error);
                });
        });
    }
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
};
